import AppConstants from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

const UIActions = {
  notifyHeaderCollapse() {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.HEADER_COLLAPSE,
    });
  },

  notifyHeaderExpand() {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.HEADER_EXPAND,
    });
  },
};

export default UIActions;
